import { appConstants } from "../_constants";
import { appHelpers } from "../_helpers";

export const invoiceCreationService = {
  getConsumersOpen,
  getIndividualsSelfServiceTypes,
  validateNin,
  validateOtp,
  getOrganizationSelfServiceTypes,
  createIndividualInvoice,
  getMakePaymentUrl
};

function getConsumersOpen(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Customer/Open/GetCustomersBDA?OrganizationID=${payload.agencyId}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getIndividualsSelfServiceTypes(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/SelfService/GetSelfServiceRevBDA?agencyId=${payload.agencyId}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function validateNin(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Identity/NINVerifyBDA?NIN=${payload.nin}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function validateOtp(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/Identity/VerifyOtpBDA`, payload)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getOrganizationSelfServiceTypes(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/SelfService/GetSelfServiceRevenuesBDA?agencyId=${payload.agencyId}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function createIndividualInvoice(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Invoice/SelfService/CreateInvoiceBDA`,
      payload
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getMakePaymentUrl(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Open/SearchInvoiceBDA?agencyId=${payload.agencyId}&invNum=${payload.invNum}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
